import React from 'react';


import Hobby from './Hobby/Hobby.js';
import HobbiesStyles from './Hobbies.module.css';


export default function Hobbies(){
    return <section id={HobbiesStyles.Hobbies}>
                <h1 id={HobbiesStyles.HobbiesHeading}>Hobbies</h1>
                <div id={HobbiesStyles.HobbiesContainer}>
                    <Hobby slideShowSpeed={800} name='Learning'/>
                    <Hobby slideShowSpeed={1500} name='Gym'/>
                    <Hobby slideShowSpeed={1000} name='Reading'/>
                    <Hobby slideShowSpeed={900} name='Drawing'/>
                    <Hobby slideShowSpeed={1200} name='Having Fun'/>
                </div>
            </section>
}